export default __webpack_public_path__ + "shared/icons/down.png";